import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { UserContext } from "../app/App";
import { Alert } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ConfigData from "../config/config.json";
import ForgotPassword from "./ForgotPassword";

const webserver = ConfigData.WEBSERVER;

export default function SignIn() {
  const { user, setUser } = React.useContext(UserContext);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [forgotPassword, setForgotPassword] = React.useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    // POST request with a x-www-form-urlencoded body to be received by the java spring /login endpoint
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body:
        "username=" +
        data.get("userName") +
        "&password=" +
        data.get("password"),
      credentials: "include",
    };

    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/login",
      requestOptions
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Ungültige Angaben!");
        }
        return response;
      })
      .then(() => {
        fetch(
          webserver.protocol +
            "://" +
            webserver.host +
            ":" +
            webserver.port +
            "/user/getRole",
          { method: "GET", credentials: "include" }
        )
          .then((response) => {
            if (response.status !== 200) {
              throw new Error("Unable to access endpoint: user/getRole");
            }
            return response;
          })
          .then((response) => response.json())
          .then((jsonData) => {
            setUser({
              name: jsonData.userName,
              authenticated: true,
              role: jsonData.role,
            });
          })
          .catch((error) => {
            // TODO Make Snackbar error popup
          });
      })
      .catch((error) => {
        setErrorMessage(error.message);
        document.getElementById("userName").value = "";
        document.getElementById("password").value = "";
        document.getElementById("userName").focus();
      });
  };

  return (
    <>
      {forgotPassword ? (
        <ForgotPassword setForgotPassword={setForgotPassword} />
      ) : (
        <Container
          component="main"
          maxWidth="xs"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <CssBaseline />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Anmelden
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="userName"
                label="Benutzername"
                name="userName"
                autoComplete="username"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Passwort"
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {errorMessage && (
                <Alert sx={{ mt: 3 }} variant="outlined" severity="error">
                  {errorMessage}
                </Alert>
              )}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 2, mb: 2 }}
              >
                Anmelden
              </Button>
              <Box sx={{ display: "flex" }}>
                <Link
                  sx={{ marginLeft: "auto" }}
                  href="#"
                  variant="body2"
                  onClick={() => setForgotPassword(true)}
                >
                  Passwort vergessen?
                </Link>
              </Box>
            </Box>
          </Box>
          <Copyright sx={{ mt: 8, mb: 4 }} />
        </Container>
      )}
    </>
  );
}

export function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://www.blak.de/">
        Bayerische Landesapothekerkammer
      </Link>{" "}
      {new Date().getFullYear()}
      {". "}
      <Link
        id="impressum"
        color="inherit"
        href="https://www.blak.de/service/impressum"
      >
        Impressum
      </Link>{" "}
    </Typography>
  );
}
